// @anthropic-ai/sdk non è bundlabile da Create React App senza eject:
// il suo modulo di risoluzione credenziali (per `ant auth login`) importa
// node:fs / node:path in modo incondizionato e webpack 5 (react-scripts)
// non li polyfilla, quindi la build fallisce. Chiamiamo l'API Messages
// direttamente via fetch — è lo stesso meccanismo che l'SDK userebbe in
// browser (header anthropic-dangerous-direct-browser-access).
// ⚠️ In React la key nel .env è esposta nel browser: ok per MVP,
// in produzione serve un backend proxy (es. Supabase Edge Function).
const API_URL = 'https://api.anthropic.com/v1/messages'
const API_VERSION = '2023-06-01'

async function create({ model, max_tokens, system, messages, output_config }) {
  const risposta = await fetch(API_URL, {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      'x-api-key': process.env.REACT_APP_ANTHROPIC_API_KEY,
      'anthropic-version': API_VERSION,
      'anthropic-dangerous-direct-browser-access': 'true',
    },
    body: JSON.stringify({ model, max_tokens, system, messages, output_config }),
  })

  const dato = await risposta.json()
  if (!risposta.ok) {
    const errore = new Error(dato?.error?.message || `Errore Claude API (${risposta.status})`)
    errore.status = risposta.status
    errore.type = dato?.error?.type
    throw errore
  }
  return dato
}

export const claude = { messages: { create } }
